import 'babel-polyfill';
import React, { lazy, Suspense } from "react"
import ReactDOM from 'react-dom';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import ReactGA from 'react-ga';
// import ReactPixel from 'react-facebook-pixel';
import { mode } from 'webconfig'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import Reducers from './Redux/reducer'

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { I18nextProvider } from "react-i18next";

import i18n from './i18n'
import Loading from '@/Common/loading/loading'

const App = lazy(() => import('./App'))

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#8bc541"
    },
    error: {
      main: "#ff4040"
    }
  }
});

initializeGoogleAnalytics()
initializeFacebookFixel()

let store
const isLocal = window.origin ? window.origin.includes('localhost') : false
if (mode === "stage" && !isLocal) 
{
  const funcs = [
    'assert', 'context', 'count', 'countReset', 'debug', 'dir', 'dirxml', 
    'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'exception', 
    'info', 'log', 'profile', 'profileEnd', 'reactStack', 'reactStackEnd', 
    'table', 'time', 'timeEnd', 'timeLog', 'timeStamp', 'trace', 'warn'
  ]
  funcs.forEach(name => { console[name] = () => {} })
  store = createStore(Reducers)
} else {
  console.log(`■ RUNNING ${mode && mode.toUpperCase()}${isLocal ? '-LOCAL' : ''} ■`);
	// **** 리덕스 개발자도구 적용
  const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  store = createStore(Reducers, devTools)
}

function RenderLoading() {
  return (
    <>
      <Loading />
    </>
  )
}

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={RenderLoading()}>
      <MuiThemeProvider theme={theme}>
        <I18nextProvider i18n={i18n}>
          <Router>
            <Route component={App} />
          </Router>
        </I18nextProvider>
      </MuiThemeProvider>
    </Suspense>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();

function initializeGoogleAnalytics() {
  if (mode !== 'stage') return

  ReactGA.initialize('UA-145921398-1', {
    debug: false,
    titleCase: false,
    gaOptions: {
      currencyCode: 'KRW'
    }
  })
  ReactGA.plugin.require('ec')
  //ReactGA.set({ currencyCode: 'KRW'})
}
function initializeFacebookFixel() {
  if (mode !== 'stage') return

  // const advancedMatching = {};
  // const options = {
  //     autoConfig: true,
  //     debug: false,
  // };
  // ReactPixel.init('316825818930804', advancedMatching, options);
}